import { HouseImgIcon } from "../house/HouseImgIcon";

export const HouseBadge = ({ thumbnailUrl, name, addClass = {} }) => (
    <div className={`${addClass} flex justify-center items-center bg-primary rounded-3xl absolute top-6 right-6 z-50 py-1.5 px-2 md:top-20 md:right-20`}>
        <p className="inline-flex w-full items-center text-2xs font-sans font-semibold text-white">
            <span className="block mr-2 w-6 h-6">
                {thumbnailUrl ? (
                    <img
                        className="rounded-full w-full h-full"
                        src={thumbnailUrl}
                        alt={name}
                    />
                ) : (
                    <HouseImgIcon className="bg-white text-primary rounded-full" />
                )}
            </span>
            {name}
        </p>
    </div>
);